import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StartPage from '../PAGES/StartPage';
import CluesPage from '../PAGES/CluesPage';
import SkillPage from '../PAGES/SkillPage';
import SizePage from '../PAGES/SizePage';
import GamePage from '../PAGES/GamePage';
import HelpPage from '../PAGES/HelpPage';
import { CLUES_PAGE } from '../const';
import { START_PAGE, GAME_PAGE, HELP_PAGE, SKILL_PAGE, SIZE_PAGE } from '../../HOME/const';
import { GOTO_START_PAGE } from '../../HOME/REDUX/actions';

const Permutile = () => {
  const dispatch = useDispatch();
  let page = useSelector(state => state.common.page);

  if (!page) {
    dispatch(GOTO_START_PAGE);
  }

  return (
    <>
      {page === START_PAGE && <StartPage />}
      {page === CLUES_PAGE && <CluesPage />}
      {page === SKILL_PAGE && <SkillPage />}
      {page === SIZE_PAGE && <SizePage />}
      {page === HELP_PAGE && <HelpPage />}
      {page === GAME_PAGE && <GamePage />}
    </>
  );
};

export default Permutile;
